import { useModerate } from "./control";
import { MOD_ATTR, type TextAnswer } from "./types";

/**
 * ═══ UNE QUESTION EN ATTENTE, ET SES TROIS VERDICTS ═══
 *
 * ⚠️ SORTIE DE `LiveRegie` POUR ÊTRE SERVIE À DEUX ENDROITS — et un seul aujourd'hui,
 * l'écran dédié. La régie ne porte plus la file : une plénière en empile des
 * centaines, et une liste qui pousse le pilotage hors de l'écran est une liste qu'on
 * consulte au mauvais moment.
 *
 * ⚠️ « METTRE À L'ÉCRAN » VALIDE AUSSI. Sans cela, la salle afficherait une question
 * que les téléphones filtrent, puisqu'ils ne reçoivent que ce que la modération a
 * retenu : une surface contredirait l'autre. Le serveur le fait dans la même
 * transaction, cet écran ne fait que le nommer.
 *
 * Displayed strings are French: this is a French product.
 */
export function QueueRow({
  answer,
  onScreen,
  elsewhere = false,
  activity,
}: {
  answer: TextAnswer;
  onScreen: boolean;
  /**
   * ⚠️ VRAI QUAND SON ACTIVITÉ N'EST PAS À L'ÉCRAN, et le bouton reste là (#349). Il
   * était caché (#341) : le serveur retenait la question pour son activité pendant que
   * la salle en regardait une autre, et rien ne s'affichait. Le serveur bascule
   * désormais la salle sur son activité dans le même geste ; la ligne le dit avant
   * le clic, parce que c'est toute la salle qui change d'activité.
   */
  elsewhere?: boolean;
  /** L'activité où elle a été posée, quand l'écran en mélange plusieurs. */
  activity?: string;
}) {
  const moderate = useModerate(answer.id);

  return (
    <div
      className="rgq"
      data-etat={etatOf(answer, onScreen)}
      data-mod={MOD_ATTR.questions}
    >
      <span>
        <b>{answer.text}</b>
        <small>
          {LABELS[answer.state ?? "received"]}
          {onScreen ? " · à l'écran" : ""}
          {activity ? ` · ${activity}` : ""}
        </small>
      </span>
      <span className="rgq__a">
        {answer.state === "kept" ? null : (
          <button
            type="button"
            disabled={moderate.isPending}
            onClick={() => moderate.mutate({ state: "kept" })}
          >
            Valider
          </button>
        )}
        <button
          type="button"
          disabled={moderate.isPending}
          title={
            elsewhere
              ? "Son activité passe aussi à l'écran, à la place de celle en cours"
              : undefined
          }
          onClick={() => moderate.mutate({ spotlight: !onScreen })}
        >
          {onScreen ? "Retirer de l'écran" : "Mettre à l'écran"}
        </button>
        {/* ⚠️ UNE QUESTION ÉCARTÉE SE REPÊCHE. On écarte vite, sous pression, et se
            tromper doit coûter un clic — pas la question de quelqu'un. */}
        {answer.state === "discarded" ? null : (
          <button
            type="button"
            data-geste="ecarter"
            disabled={moderate.isPending}
            onClick={() => moderate.mutate({ state: "discarded" })}
          >
            Écarter
          </button>
        )}
      </span>
    </div>
  );
}

const LABELS: Record<string, string> = {
  received: "En attente",
  kept: "Validée",
  discarded: "Écartée",
};

/* La feuille distingue une question retenue d'une question écartée : la première
   porte un filet vert, la seconde s'estompe. */
function etatOf(answer: TextAnswer, onScreen: boolean): string | undefined {
  if (answer.state === "discarded") return "ecarte";
  if (answer.state === "kept" || onScreen) return "ok";
  return undefined;
}
